import type { GoalMetric } from './domain';
import type { ScoreSummary } from './scoring';

export type GoalLike = { id: string; metric: GoalMetric; section_key: string | null; target: number; label: string };
export type GoalResult = { goal_id: string; label: string; metric: GoalMetric; section_key: string | null; target: number; actual: number; met: boolean };

export function describeGoal(g: Pick<GoalLike, 'metric' | 'target' | 'section_key' | 'label'>, sectionLabel?: string): string {
  if (g.label) return g.label;
  switch (g.metric) {
    case 'overall_score':
      return `Overall score ≥ ${g.target}%`;
    case 'section_score':
      return `${sectionLabel ?? g.section_key ?? 'Section'} ≥ ${g.target}%`;
    case 'max_failed_items':
      return `No more than ${g.target} failed items`;
  }
}

// Evaluates goals against a score summary. Section goals for sections missing from
// the template are skipped.
export function evaluateGoals(goals: GoalLike[], summary: ScoreSummary): GoalResult[] {
  const out: GoalResult[] = [];
  for (const g of goals) {
    let actual: number;
    let met: boolean;
    if (g.metric === 'overall_score') {
      actual = summary.score;
      met = actual >= g.target;
    } else if (g.metric === 'section_score') {
      if (!g.section_key || !(g.section_key in summary.section_scores)) continue;
      actual = summary.section_scores[g.section_key];
      met = actual >= g.target;
    } else {
      actual = summary.failed;
      met = actual <= g.target;
    }
    out.push({ goal_id: g.id, label: g.label, metric: g.metric, section_key: g.section_key, target: g.target, actual, met });
  }
  return out;
}
